import {
  ArticleEntryData,
  ENTRY_DATA_LICENSEE_TABLE as LICENSEE_TABLE_KEY,
} from "@frontend/common";

import useArticleSection from "@FillInTableContainer/hooks/useArticleSection";
import { useCurrentDealTypeValue } from "@FillInTableContainer/shared/context/CurrentDealTypeContext";
import { useEntryDataValue } from "@stores/entryData";
import { getPressIdFromURL } from "@utils/getStateFromURL";

import { checkTargetDealSwapRolesByTableKey } from "../utils/checkTargetDealSwapRolesByTableKey";
import { isDealSwapRolesSection } from "../utils/isDealSwapRolesSection";

type Props = {
  tableKey: string | null;
};

export const useCheckDealSwapRoles = ({ tableKey }: Props) => {
  const pressId = getPressIdFromURL();
  const entryData = useEntryDataValue(pressId);
  const articleSection = useArticleSection();
  const { isMergeAndAcquisition } = useCurrentDealTypeValue();

  const checkDealSwapRoleByEntryData = (currentEntryData: ArticleEntryData) => {
    if (!isDealSwapRolesSection(articleSection)) return false;

    if (!currentEntryData?.[articleSection]) return false;

    const countLicenseeTable =
      currentEntryData[articleSection]?.[LICENSEE_TABLE_KEY]?.length || 0;
    const LICENSEE_TABLE_COUNT_CRITERIA = 1;

    return countLicenseeTable === LICENSEE_TABLE_COUNT_CRITERIA;
  };

  const isTargetDealSwapRoles =
    !isMergeAndAcquisition &&
    checkTargetDealSwapRolesByTableKey(tableKey) &&
    checkDealSwapRoleByEntryData(entryData);

  return {
    isTargetDealSwapRoles,
  };
};
